import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Select, Form as FormInitial } from "antd";
import {
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
  SelectItem,
  Form,
  HeaderItem,
  BoxItem,
  cuentaMask,
  SwitchItem,
} from "../../../../Components/Items";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import SelectClientesItem from "../../../../Components/SelectClientesItem";

const { Option } = Select;

class EditarCaja extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    loadingData: false,
    todasBancos: [],
    cajaData: null,
    objetoProyectos: [],
    todasProyectos: [],
    objetoClientes: [],
    todasClientes: [],
    objetoPrecios: [],
    todasPrecios: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.cajaId) {
      this.consultarTodo();
    }

    if (!this.props.visible && prevProps.visible) {
      this.limpiarFormulario();
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  consultarTodo() {
    this.setState({ loading: true });

    Promise.all([
      axios.post(
        "cajas/selectDatosParaCaja",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
      axios.post(
        "cajas/datosCaja",
        { cajaId: this.props.cajaId },
        { headers: this.props.headersToken }
      ),
    ])
      .then(([datosRes, cajaRes]) => {
        this.setState({ loading: false });

        // Corregir la validación de éxito
        if (
          datosRes.data.success === 2 &&
          cajaRes.data.success === 2
        ) {
          const cajaData = cajaRes.data.caja;

          this.setState({
            todasBancos: datosRes.data.bancos.map((banco) => (
              <Option key={banco._id} value={banco._id}>
                {banco.nombre}
              </Option>
            )),
            todasPrecios: datosRes.data.precios.precios.map((precio) => (
              <Option key={precio._id} value={precio._id}>
                {precio.nombre}
              </Option>
            )),
            objetoProyectos: datosRes.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoCuentaContable: datosRes.data.cuentasContablesFinales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
            cajaData: cajaData,
          });


          this.formRef.current.setFieldsValue({
            ...cajaData,
            codigo: cajaData.codigo,
            nombre: cajaData.nombre,
            bancoTarjeta: Array.isArray(cajaData.bancoTarjeta)
              ? cajaData.bancoTarjeta.map((item) => item?._id || item)
              : [],
            proyectoId: cajaData.proyectoId?._id || cajaData.proyectoId,
            clienteId: cajaData.clienteId?._id || cajaData.clienteId,
            precioId: cajaData.precioId?._id || cajaData.precioId,
          });
        } else {
          message.error("Error al cargar los datos1");
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        message.error("Error al cargar los datos2");
        console.error(error);
      });
  }

  limpiarFormulario = () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({ cajaData: null });
  };

  onFinish(values) {

    if (values?.bancoTarjeta?.length === 0) {
      return message.error("Debe seleccionar al menos un banco de tarjeta");
    }
    if (values?.nombre) {
      this.setState({ loading: true });
      axios
        .post(
          "cajas/editarCaja",
          {
            ...values,
            cajaId: this.props.cajaId,
            empresaId: this.props.empresaId,
          },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Caja editada exitosamente");
            this.cerrarEditarCaja();
          } else if (res.data.success === 1) {
            message.error("No se pudo editar la caja");
          } else {
            message.error("Sucedió un error y no se pudo editar la caja");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el nombre de la caja");
    }
  }

  cerrarEditarCaja = () => {
    this.props.cerrarEditarCaja();
    this.limpiarFormulario();
  };

  render() {
    return (
      <ModalItem
        title="Editar Caja"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarEditarCaja.bind(this)}
      >
        <Form
          ref={this.formRef}
          name="modalEditarCaja"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Actualizar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="codigo"
            label="Número de Caja"
            required
            margin
          >
            <InputItem disabled placeholder="Ingresa el número de Caja" />
          </FormItem>

          <FormItem
            name="nombre"
            label="Caja"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre de la caja" />
          </FormItem>

          <FormItem
            name="proyectoId"
            label="Proyecto"
            required
            margin
          >
            <SelectItem placeholder="Elija el Proyecto">
              {this.state.objetoProyectos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="clienteId"
            label="Cliente Por Defecto"
            required
            margin
          >
            <SelectClientesItem
              empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
              headersToken={this.props.headersToken}
              sinBorde
              autoFocus
              dropdownMatchSelectWidth={600}
              width="100%"
              placeholder="Elija el Cliente"
            />
          </FormItem>
          <FormItem
            name="precioId"
            label="Precios"
            required
            margin
          >
            <SelectItem placeholder="Elija el Precio">
              {this.state.todasPrecios}
            </SelectItem>
          </FormItem>
          <FormItem
            name="listaCliente"
            label="Usar lista del cliente"
            margin
            initialValue={false}
            valuePropName="checked"
            tooltip = "Se usará la lista por defecto que el cliente tenga definida como precio de menudeo"
          >
            <SwitchItem />
          </FormItem>
          <FormItem
            name="bancoEfectivo"
            label="Banco Efectivo"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="bancoVales"
            label="Banco Vales"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="bancoCheques"
            label="Banco Cheques"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <FormItem
            name="bancoTransferencia"
            label="Banco Transferencia"
            required
            margin
          >
            <SelectItem placeholder="Elija el banco">
              {this.state.todasBancos}
            </SelectItem>
          </FormItem>
          <HeaderItem>Tarjeta</HeaderItem>
          <BoxItem>
            <FormInitial.List name="bancoTarjeta">
              {(fields, { add, remove }) => (
                <div style={{ marginBottom: 24 }}>
                  {fields.map((field, index) => (
                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <FormItem
                        {...field}
                        label={"Banco Tarjeta"}
                        name={field.name}
                        required
                        fieldKey={field.fieldKey}
                        style={{ flex: 1, marginBottom: 0, marginRight: 8 }}
                      >
                        <SelectItem placeholder="Elija el banco">
                          {this.state.todasBancos}
                        </SelectItem>
                      </FormItem>

                      {fields.length > 1 && (
                        <ButtonItem
                          onClick={() => remove(field.name)}
                          icon={<MinusCircleOutlined />}
                          style={{
                            color: '#999999',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '4px'
                          }}
                        />
                      )}
                    </div>
                  ))}

                  <ButtonItem
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    block
                    style={{ marginTop: 8 }}
                  >
                    Agregar Banco
                  </ButtonItem>
                </div>
              )}
            </FormInitial.List>
          </BoxItem>

          <HeaderItem>Retiros o Depósitos</HeaderItem>
          <BoxItem>
            <FormInitial.List name="cajasRetiros">
              {(fields, { add, remove }) => (
                <div style={{ marginBottom: 24 }}>
                  {fields.map((field, index) => (
                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <FormItem
                        {...field}
                        label="Banco/Caja Retiros"
                        name={field.name}
                        required
                        fieldKey={field.fieldKey}
                        style={{ flex: 1, marginBottom: 0, marginRight: 8 }}
                      >
                        <SelectItem placeholder="Elija el banco / caja">
                          {this.state.todasBancos}
                        </SelectItem>
                      </FormItem>


                      {fields.length > 1 && (
                        <ButtonItem
                          onClick={() => remove(field.name)}
                          icon={<MinusCircleOutlined />}
                          style={{
                            color: '#999999',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '4px'
                          }}
                        />
                      )}
                    </div>
                  ))}

                  <ButtonItem
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    block
                    style={{ marginTop: 8 }}
                  >
                    Agregar Banco/Caja Retiros
                  </ButtonItem>
                </div>
              )}
            </FormInitial.List>
            <FormInitial.List name="cajasIngresos">
              {(fields, { add, remove }) => (
                <div style={{ marginBottom: 24 }}>
                  {fields.map((field, index) => (
                    <div key={field.key} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <FormItem
                        {...field}
                        label="Banco/Caja Ingresos"
                        name={field.name}
                        required
                        fieldKey={field.fieldKey}
                        style={{ flex: 1, marginBottom: 0, marginRight: 8 }}
                      >
                        <SelectItem placeholder="Elija el banco / caja">
                          {this.state.todasBancos}
                        </SelectItem>
                      </FormItem>


                      {fields.length > 1 && (
                        <ButtonItem
                          onClick={() => remove(field.name)}
                          icon={<MinusCircleOutlined />}
                          style={{
                            color: '#999999',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '4px'
                          }}
                        />
                      )}
                    </div>
                  ))}

                  <ButtonItem
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    block
                    style={{ marginTop: 8 }}
                  >
                    Agregar Banco/Caja Ingresos
                  </ButtonItem>
                </div>
              )}
            </FormInitial.List>
          </BoxItem>
          <HeaderItem>Cuentas Contables</HeaderItem>
          <BoxItem>
            <FormItem
              label="Permitir Otros Retiros"
              name="permitirOtrosRetiros"
              margin
              initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se pueden realizar otros retiros. (No recomendable)"
            >
              <SwitchItem />
            </FormItem>
            <FormItem shouldUpdate={(prevValues, currentValues) => prevValues.permitirOtrosRetiros !== currentValues.permitirOtrosRetiros} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('permitirOtrosRetiros') && (
                  <FormItem name="cuentaContableRetiroId" label="Cuenta Contable Retiro" required margin>
                    <SelectItem placeholder="Cuenta Contable Retiro" width="100%">
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                )
              }
            </FormItem>
            <FormItem
              label="Permitir Otros Ingresos"
              name="permitirOtrosIngresos"
              margin
              initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se pueden realizar otros ingresos. (No recomendable)"
            >
              <SwitchItem />
            </FormItem>
            <FormItem shouldUpdate={(prevValues, currentValues) => prevValues.permitirOtrosIngresos !== currentValues.permitirOtrosIngresos} noStyle>
              {({ getFieldValue }) =>
                getFieldValue('permitirOtrosIngresos') && (
                  <FormItem name="cuentaContableDepositoId" label="Cuenta Contable Depósito" required margin>
                    <SelectItem placeholder="Cuenta Contable Depósito" width="100%">
                      {this.state.objetoCuentaContable}
                    </SelectItem>
                  </FormItem>
                )
              }
            </FormItem>
          </BoxItem>
          <HeaderItem>Impresión de Tickets</HeaderItem>
          <BoxItem>
            <FormItem
              label="Imprimir Ticket de Cobro"
              name="ticketCobro"
              margin
              //initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se imprime el ticket de la factura."
            >
              <SwitchItem />
            </FormItem>
            <FormItem
              label="Imprimir Ticket de Factura"
              name="ticketFactura"
              margin
              //initialValue={false}
              valuePropName="checked"
              tooltip="Si esta activado, se imprime el ticket de la factura."
            >
              <SwitchItem />
            </FormItem>
          </BoxItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarCaja);
